module.exports = __webpack_public_path__ + "img/objetivo_17.9ac89ec3.webp";